import { TooltipComponent } from '@components/core/tooltip.component';
import { Button } from '@components/ui/button';
import { cn } from '@lib/utils';
import { IconButton } from '../core/icon-button.component';

export type TileHeaderProps = {
  actions?: React.ReactNode;
  button?: { onClick: () => void; text: string };
  className?: string;
  iconButton?: {
    ariaLabel?: string;
    disabled?: boolean;
    disabledTooltip?: string;
    icon: React.ReactNode;
    isVisible?: boolean;
    onClick: () => void;
  };
  title?: string | React.ReactNode;
};

export const TileHeader: React.FC<TileHeaderProps> = (props) => {
  const { actions, button, className, iconButton, title } = props;

  // Check if any action elements are present
  const hasActions = button || iconButton || actions;

  const renderIconButton = () => {
    if (!iconButton) return null;

    const buttonElement = (
      <IconButton
        ariaLabel={iconButton.ariaLabel}
        disabled={iconButton.disabled}
        icon={iconButton.icon}
        isVisible={iconButton.isVisible ?? true}
        onClick={iconButton.onClick}
        variant="secondary"
      />
    );

    if (iconButton.disabled && iconButton.disabledTooltip) {
      return (
        <TooltipComponent
          side="top"
          trigger={<span>{buttonElement}</span>}
        >
          {iconButton.disabledTooltip}
        </TooltipComponent>
      );
    }

    return buttonElement;
  };

  return (
    <div
      className={cn(
        'flex flex-row items-center w-full flex-wrap gap-2',
        !title && hasActions ? 'justify-end' : 'justify-between',
        className,
      )}
    >
      {title && <div className="text-sm flex-1 font-semibold text-gray-900">{title}</div>}

      {hasActions && (
        <div className="flex flex-row items-center gap-2">
          {actions}
          {button && (
            <Button
              onClick={() => button.onClick()}
              variant="link"
            >
              {button.text}
            </Button>
          )}
          {renderIconButton()}
        </div>
      )}
    </div>
  );
};
